import React from "react";
import { CiEdit } from "react-icons/ci";
import { RiDeleteBinLine } from "react-icons/ri";
import { Helmet } from "react-helmet-async";

const blogs = [
  {
    title: "Understanding React",
    content:
      "React is a JavaScript library for building user interfaces. It allows developers to create large web applications that can update and render efficiently in response to data changes.",
    image: "https://via.placeholder.com/600x400",
  },
  {
    title: "Components and Props",
    content:
      "Components are the building blocks of a React application. They let you split the UI into independent, reusable pieces, and think about each piece in isolation.",
    image: "https://via.placeholder.com/600x400",
  },
  {
    title: "State and Lifecycle",
    content:
      "State is similar to props, but it is private and fully controlled by the component. Lifecycle methods are special methods that are automatically called during different phases of a component's life.",
    image: "https://via.placeholder.com/600x400",
  },
  {
    title: "State and Lifecycle",
    content:
      "State is similar to props, but it is private and fully controlled by the component. Lifecycle methods are special methods that are automatically called during different phases of a component's life.",
    image: "https://via.placeholder.com/600x400",
  },
];

function ManageBlog() {
  return (
    <div className="p-4 w-full">
      <Helmet>
        <title>
          Khadoom | Manage Blogs
        </title>
      </Helmet>
      <h1 className="text-2xl text-[#000000] font-semibold font-gotham  mb-6">Blog Posts</h1>
      <div className="w-full grid gap-5 grid-cols-1  md:grid-cols-3 lg:grid-cols-4">
        {blogs.map((blog, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-lg overflow-hidden"
          >
            <img
              src={blog.image}
              alt={blog.title}
              className="w-full h-48 object-cover"
            />{" "}
            <div className="flex justify-end gap-5 p-3">
              {" "}
              <CiEdit className="text-xl  " />
              <RiDeleteBinLine className="text-xl" />
            </div>
            <div className="p-4 font-gotham">
              <h2 className="text-xl font-semibold mb-2 text-blue-600 ">
                {blog.title}
              </h2>
              <p className="text-gray-700">{blog.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ManageBlog;
